import { Injectable } from '@angular/core';
import { TenantCompany } from '../../models/tenant-company/tenant-company.model';

@Injectable({
  providedIn: 'root'
})
export class MapperTenantCompanyService {
  constructor() { }

  public mapFromDto(dto: any): TenantCompany {
    return {
      id: dto.id || 0,
      name: dto.name || '',
      address: dto.address || '',
      phone: dto.phone || '',
      taxId: dto.taxId || '',
      contactPerson: dto.contactPerson || '',
      branch: dto.branch || '',
      remark: dto.remark || '',
      tenantType: dto.tenantType || '',
      providerName: dto.providerName || '',
      siteName: dto.siteName || '',
      wh: dto.wh || 0,
      reserveQuota: dto.reserveQuota || 0,
      reserveUsed: dto.reserveUsed || 0,
      carUsed: dto.carUsed || 0,
      carTotal: dto.carTotal || 0,
    };
  }
}
